import products from '../../fixtures/apiResponses/searchProducts.json';
import MockApi from './MockApi';

// TODO написать ридми для внедрения
export default class SearchProducts {
	static fetch() {
		return MockApi.get({ data: products });
	}
}
